import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { BehaviorSubject } from 'rxjs';
import { StatusService } from 'src/@order/services/status.service';
import { OrderPool, ordersTracking } from 'src/app/utils/systemEnums';

@Component({
    selector: 'app-order-live-status',
    templateUrl: './order-live-status.component.html',
    styleUrls: ['./order-live-status.component.scss'],
})
export class OrderLiveStatusComponent implements OnInit, OnDestroy {
    public statusData = [
        { id: 1, title: 'Order Confirmed', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 2, title: 'Delivery Booked', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 3, title: 'Driver Found', status: 0 }, // undone == 0 || pending == 1 || done == 2
        { id: 4, title: 'Preparing Delivery', status: 0 }, // undone == 0 || pending == 1 || done == 2
    ];

    liveSecondToShow: BehaviorSubject<number> = new BehaviorSubject(0);
    liveSecond$ = this.liveSecondToShow.asObservable();

    @Input('orderData') orderData: any;
    @Input('orderId') orderId: any;

    progressValue;
    public messages: string = '';
    updatedDoc: any;
    currentTime = new Date();
    orderTimeStamp;
    liveSecondCountToInter
    formattedTime;
    isNeedToShow: boolean = false;

    constructor(private afs: AngularFirestore, private _StatusService: StatusService) {
    }


    ngOnInit(): void {

        this.getOrderDataFromFireBase();

        this._StatusService.liveSecondSub.subscribe((liveSecond:number) =>{
            const runingItem: any = this.statusData.filter((item) => item.status == 1);
            if (runingItem?.length) {

                if (runingItem[0].id == 1 && runingItem[0].status == 1) { 
                    this.updateFormattedTime(10 - liveSecond); // 10 se decrement count show karenge     
                } else if (runingItem[0].id == 2 && runingItem[0].status == 1) { 
                    this.updateFormattedTime(40 - liveSecond); 
                } else if (runingItem[0].id == 3 && runingItem[0].status == 1) {
                    this.updateFormattedTime(280 - liveSecond)
                } else if (runingItem[0].id == 4 && runingItem[0].status == 1) { 
                    this.updateFormattedTime(360 - liveSecond);
                } else if (runingItem[0].id == 4 && runingItem[0].status == 2) {
                    this.updateFireBaseStatus(); 
                }
            }
        })

        this._StatusService.isProcessComplated.subscribe((res)=>{
            if(res){
                this.isNeedToShow = false;
            }
        })


        this._StatusService.statusData.subscribe((orderLiveStatus) => {
            this.statusData = orderLiveStatus;
            const runingItem: any = this.statusData.filter((item) => item.status == 1);
            if (runingItem?.length) {
                // if (runingItem[0].id == 1 && runingItem[0].status == 1) {
                    
                //     this.updateFormattedTime(10 - liveSecond); // 10 se decrement count show karenge
                        
                // } else if (runingItem[0].id == 2 && runingItem[0].status == 1) {
                //     clearInterval(this.liveSecondCountToInter)
                //     let liveSecond = 30;
                //     this.liveSecondToShow.next(liveSecond);
                //     this.liveSecondCountToInter = setInterval(() => {
                //         this.updateFormattedTime(liveSecond)
                //         liveSecond--;
                //         this.liveSecondToShow.next(liveSecond);
                //         if (liveSecond == 0) {
                //             clearInterval(this.liveSecondCountToInter)
                //         }
                //     }, 1000);
                // } else if (runingItem[0].id == 3 && runingItem[0].status == 1) {
                //     clearInterval(this.liveSecondCountToInter)
                //     let liveSecond = 240;
                //     this.liveSecondToShow.next(liveSecond);
                //     this.liveSecondCountToInter = setInterval(() => {
                //         this.updateFormattedTime(liveSecond)
                //         liveSecond--;
                //         this.liveSecondToShow.next(liveSecond);
                //         if (liveSecond == 0) {
                //             clearInterval(this.liveSecondCountToInter)
                //         }
                //     }, 1000);
                // } else if (runingItem[0].id == 4 && runingItem[0].status == 1) {
                //     clearInterval(this.liveSecondCountToInter)
                //     let liveSecond = 80;
                //     this.liveSecondToShow.next(liveSecond);
                //     this.liveSecondCountToInter = setInterval(() => {
                //         this.updateFormattedTime(liveSecond)
                //         liveSecond--; 
                //         this.liveSecondToShow.next(liveSecond);
                //         if (liveSecond == 0) {
                //             clearInterval(this.liveSecondCountToInter)
                //         }
                //     }, 1000);
                // } else if (runingItem[0].id == 4 && runingItem[0].status == 2) {
                //     this.updateFireBaseStatus();
                //     setTimeout(() => {
                //         this.isNeedToShow = false;
                //     }, 3000);
                // }
            }

        })


        this._StatusService.liveMessageUpdate.subscribe((messagesString) => {
            this.messages = messagesString;
        })

    }

    updateFormattedTime(counter) {
        const minutes = Math.floor(counter / 60);
        const seconds = counter % 60;
        this.formattedTime = `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
    }

    updateOrderCreationTime() {
        const tenSecond = new Date(this.currentTime.getTime() - 10 * 1000).getTime();
        const thirtySecond = new Date(this.currentTime.getTime() - 40 * 1000).getTime();
        const twoHundredFortySecond = new Date(this.currentTime.getTime() - 280 * 1000).getTime();
        const ninetySecond = new Date(this.currentTime.getTime() - 410 * 1000).getTime();

        const orderTime = this.orderData.order_id;
        // const orderTime = new Date(this.currentTime.getTime() - 320 * 1000).getTime();

        if (orderTime > tenSecond) {
            console.log("in 10 tenSecond");
            this._StatusService.processStatuses(0)
        }
        else if (orderTime > thirtySecond) {
            console.log("in 10 thirtySecond");
            this._StatusService.processStatuses(10);
        }
        else if (orderTime > twoHundredFortySecond) {
            console.log("in 10 twoHundredFortySecond");
            this._StatusService.processStatuses(40)
        }
        else if (orderTime > ninetySecond) {
            console.log("in 10 ninetySecond");
            this._StatusService.processStatuses(280)
        }



    }

    getOrderDataFromFireBase() {

        const OrderFireData = this.afs.collection(ordersTracking).doc(String(this.orderData.id));

        OrderFireData.valueChanges().subscribe((updatedDoc: any) => {
            console.log("updatedDoc", updatedDoc);
            this.updatedDoc = updatedDoc;

            if (this.updatedDoc.details.bookingStepsCompleted) {
                this.statusData.map((item) => (item.status = 2));
            } else {

                const pervtime = new Date(this.currentTime.getTime() - 410 * 1000).getTime();
                this.orderTimeStamp = this.orderData.order_id;

                if (this.orderData.order_id > pervtime) {
                    console.log("need to show");
                    this.isNeedToShow = true;
                    this.updateOrderCreationTime();
                } else {
                    console.log("need to hide");
                    this.isNeedToShow = false;

                }

            }
        });
    }

    updateFireBaseStatus() {
        this.updatedDoc.details.bookingStepsCompleted = true;
        const docRef = this.afs.collection(ordersTracking).doc(String(this.orderData.id));
        docRef.update(this.updatedDoc);
    }

    
    ngOnDestroy(): void {
        clearInterval(this._StatusService.liveInterval);
        this._StatusService.liveInterval = null;
        clearInterval(this.liveSecondCountToInter);
    }
}
